// src/components/LoginForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginForm.module.css';
import masaLogo from '../Assets/MasaLogo.png';
import { resolveHomePath } from '../utils/navigation';

function LoginForm() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch('/api/auth/login', { // Updated to relative URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || 'Login failed. Please try again.');
        return;
      }

      const { token } = await response.json();
      const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload

      // Save the token in localStorage (optional for persistence)
      localStorage.setItem('authToken', token);

      const homePath = resolveHomePath(payload.userType);
      if (homePath === '/') {
        setErrorMessage('Invalid user type.');
        return;
      }
      navigate(homePath);
    } catch (error) {
      console.error('Error during login:', error);
      setErrorMessage('An error occurred. Please try again.');
    }
  };

  return (
    <section className={styles.loginPage}>
      <form className={styles.loginCard} onSubmit={handleLogin} autoComplete="on">
        <div className={styles.logoWrap}>
          <img src={masaLogo} alt="Masa" />
        </div>
        <h1 className={styles.loginTitle}>Sign in to Masa</h1>

        <div className={styles.inputGroup}>
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            placeholder="e.g. johndoe"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="password">Password</label>
          <div className={styles.passwordField}>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.togglePasswordButton}
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>

        {errorMessage && (
          <div className={styles.errorBanner} role="alert" aria-live="assertive">
            <span>{errorMessage}</span>
            <button onClick={() => setErrorMessage(null)} type="button">
              Dismiss
            </button>
          </div>
        )}

        <button type="submit" className={styles.submitButton}>
          Sign in
        </button>
      </form>
    </section>
  );
}

export default LoginForm;
